<template>
	<div style="display: flex;flex-direction: column;">
		<div style="width: 100%;background-color: #fff;margin-top: 20px;">
			<div style="padding: 10px;font-weight: bold;font-size: 18px;">面包屑设置</div>
			<div style="height:  1px;background-color: #c7c7c7;margin: auto;margin: 6px;"></div>
			<div class="flex-item-center"
				style="align-items: center;margin: 10px;display: flex;margin-top: 10px;font-size: 14px;">
				<div style="font-size: 14px;">是否显示</div>
				<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
					<div @click="dataItem.breadcrumb.isShow = true"
						:style="{backgroundColor: dataItem.breadcrumb.isShow?'#8c62ff':'#fff',color: dataItem.breadcrumb.isShow?'#fff':'#000',border: dataItem.breadcrumb.isShow?'solid 1px #8c62ff':'solid 1px #959595' }"
						style="padding: 4px 0px;width: 36px;text-align: center;">
						<span style="scale: 0.85;">是</span>
					</div>
					<div @click="dataItem.breadcrumb.isShow = false"
						:style="{backgroundColor:!dataItem.breadcrumb.isShow?'#8c62ff':'#fff',color: !dataItem.breadcrumb.isShow?'#fff':'#000',border: !dataItem.breadcrumb.isShow?'solid 1px #8c62ff':'solid 1px #959595' }"
						style="padding: 4px 0px;width: 36px;text-align: center;">
						<span style="scale: 0.85;">否</span>
					</div>
				</div>
			</div>

			<div class="flex-item-center"
				style="align-items: center;margin: 10px;display: flex;margin-top: 10px;font-size: 14px;">
				<div style="font-size: 14px;">文字位置</div>
				<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
					<div @click="dataItem.breadcrumb.titPosition = 'start'"
						:style="{backgroundColor: dataItem.breadcrumb.titPosition == 'start'?'#8c62ff':'#fff',color: dataItem.breadcrumb.titPosition == 'start'?'#fff':'#000',border: dataItem.breadcrumb.titPosition == 'start'?'solid 1px #8c62ff':'solid 1px #959595' }"
						style="padding: 4px 0px;width: 36px;text-align: center;">
						<span style="scale: 0.85;">靠左</span>
					</div>
					<div @click="dataItem.breadcrumb.titPosition = 'center'"
						:style="{backgroundColor:dataItem.breadcrumb.titPosition == 'center'?'#8c62ff':'#fff',color: dataItem.breadcrumb.titPosition == 'center'?'#fff':'#000',border: dataItem.breadcrumb.titPosition == 'center'?'solid 1px #8c62ff':'solid 1px #959595' }"
						style="padding: 4px 0px;width: 36px;text-align: center;">
						<span style="scale: 0.85;">居中</span>
					</div>
					<div @click="dataItem.breadcrumb.titPosition = 'end'"
						:style="{backgroundColor:dataItem.breadcrumb.titPosition == 'end'?'#8c62ff':'#fff',color: dataItem.breadcrumb.titPosition == 'end'?'#fff':'#000',border: dataItem.breadcrumb.titPosition == 'end'?'solid 1px #8c62ff':'solid 1px #959595' }"
						style="padding: 4px 0px;width: 36px;text-align: center;">
						<span style="scale: 0.85;">靠右</span>
					</div>
				</div>
			</div>

			<div style="padding: 10px;display: flex;">
				<div style="font-size: 14px;">文字容器宽度设置</div>
				<div style="margin-left: 10px;">
					<div style="display: flex;align-items: center;font-size: 12px;cursor: pointer;">
						<div @click="dataItem.breadcrumb.titType = 'allWidth'"
							:style="{backgroundColor: dataItem.breadcrumb.titType == 'allWidth'?'#605bf6':'#fff',color: dataItem.breadcrumb.titType == 'allWidth'?'#fff':'#000'}"
							style="width: 120px;border-radius: 6px 0px 0px 6px;padding: 4px;border: solid 1px #c7c7c7;text-align: center;">
							全宽
						</div>
						<div @click="dataItem.breadcrumb.titType = 'box'"
							:style="{backgroundColor: dataItem.breadcrumb.titType == 'box'?'#605bf6':'#fff',color: dataItem.breadcrumb.titType == 'box'?'#fff':'#000'}"
							style="width: 120px;padding: 4px;border: solid 1px #c7c7c7;border-radius: 0px 6px 6px 0px;text-align: center;">
							盒装
						</div>
					</div>
				</div>
			</div>

			<div v-if="dataItem.breadcrumb.titType == 'box'"
				style="margin-left: 10px;display: flex;align-items: center;margin-bottom: 10px;">
				<div style="font-size: 14px;">盒装容器宽度设置</div>
				<el-input size="small" @change="changeIpt(dataItem.breadcrumb)"
					style="width: 259px;margin-top: 10px;margin-left: 10px;" placeholder="请输入内容"
					v-model="dataItem.breadcrumb.titBoxWidth" clearable>
					<template slot="append">px</template>
				</el-input>
			</div>

			<div style="display: flex;align-items: center;">
				<div style="padding: 10px;display: flex;align-items: center;margin-top: 10px;font-size: 14px;">
					<div>字体颜色</div>
					<el-color-picker style="margin-left: 10px;" v-model="dataItem.breadcrumb.color"></el-color-picker>
				</div>
				<div style="padding: 10px;display: flex;align-items: center;margin-top: 10px;font-size: 14px;">
					<div>当前页字体颜色</div>
					<el-color-picker style="margin-left: 10px;"
						v-model="dataItem.breadcrumb.currentColor"></el-color-picker>
				</div>
				<div style="padding: 10px;display: flex;align-items: center;margin-top: 10px;font-size: 14px;">
					<div>字体悬停颜色</div>
					<el-color-picker style="margin-left: 10px;"
						v-model="dataItem.breadcrumb.hoverColor"></el-color-picker>
				</div>
			</div>

			<div style="display: flex;align-items: center;font-size: 14px;">
				<div style="padding: 10px;display: flex;align-items: center;margin-top: 10px;font-size: 14px;">
					<div>字体大小</div>
					<input @input="iptTit(dataItem.breadcrumb)" v-model="dataItem.breadcrumb.fontSize"
						style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;margin-left: 10px;" />px
				</div>
				<el-select size="mini" style="width: 100px;margin-top:10px" v-model="dataItem.breadcrumb.fontFamily"
					placeholder="选择字体">
					<el-option v-for="(fontItem,index) in fontList" :key="index" :label="fontItem.code"
						:value="fontItem.name">
					</el-option>
				</el-select>
			</div>

			<div style="display: flex;align-items: center;font-size: 14px;">

				<div style="" class="flex-item-center"
					style="align-items: center;margin: 6px;display: flex;margin-top: 10px;">
					<div style="font-size: 14px;">组件边框</div>
					<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
						<div @click="dataItem.breadcrumb.border.type = ''"
							:style="{backgroundColor: dataItem.breadcrumb.border.type == ''?'#8c62ff':'#fff',color: dataItem.breadcrumb.border.type == ''?'#fff':'#000',border: dataItem.breadcrumb.border.type == ''?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="padding: 4px 0px;width: 36px;text-align: center;">
							<span style="scale: 0.85;">无</span>
						</div>
						<div @click="dataItem.breadcrumb.border.type = 'solid'"
							:style="{backgroundColor: dataItem.breadcrumb.border.type == 'solid'?'#8c62ff':'#fff',color: dataItem.breadcrumb.border.type == 'solid'?'#fff':'#000',border: dataItem.breadcrumb.border.type == 'solid'?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="padding: 4px 0px;width: 36px;text-align: center;">
							<span style="scale: 0.85;">实线</span>
						</div>
						<div @click="dataItem.breadcrumb.border.type = 'dashed'"
							:style="{backgroundColor:dataItem.breadcrumb.border.type == 'dashed'?'#8c62ff':'#fff',color:dataItem.breadcrumb.border.type == 'dashed'?'#fff':'#000',border:dataItem.breadcrumb.border.type == 'dashed'?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="padding: 4px 0px;width: 36px;text-align: center;">
							<span style="scale: 0.85;">虚线</span>
						</div>
					</div>
				</div>
				<div style="padding: 10px;display: flex;align-items: center;margin-top: 10px;font-size: 14px;">
					<div>边框颜色</div>
					<el-color-picker style="margin-left: 10px;"
						v-model="dataItem.breadcrumb.border.color"></el-color-picker>
				</div>
			</div>



			<div style="display: flex;align-items: center;">
				<div style="display: flex;align-items: center;">
					<div style="padding: 10px;display: flex;align-items: center;margin-top: 10px;font-size: 14px;">
						<div>线条大小</div>
						<div
							style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
							<div style="display: flex;flex-direction: column;align-items: center;">
								<input @input="changeContainerSize" v-model="dataItem.breadcrumb.border.borderSize[0]"
									style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
								<div style="margin-top: 2px;">顶部</div>
							</div>
							<div style="display: flex;flex-direction: column;align-items: center;">
								<input @input="changeContainerSize" v-model="dataItem.breadcrumb.border.borderSize[1]"
									style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
								<div style="margin-top: 2px;">左侧</div>
							</div>
							<div style="display: flex;flex-direction: column;align-items: center;">
								<input @input="changeContainerSize" v-model="dataItem.breadcrumb.border.borderSize[2]"
									style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
								<div style="margin-top: 2px;">底部</div>
							</div>
							<div style="display: flex;flex-direction: column;align-items: center;">
								<input @input="changeContainerSize" v-model="dataItem.breadcrumb.border.borderSize[3]"
									style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
								<div style="margin-top: 2px;">右侧</div>
							</div>
							<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
								<i @click="borderContainerSizeAll = !borderContainerSizeAll"
									:style="{color:borderContainerSizeAll?'#8c62ff':'#000'}"
									style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
									class="el-icon-paperclip tit-icon"></i>
							</div>
						</div>
					</div>
				</div>

				<div style="display: flex;align-items: center;">
					<div style="padding: 10px;display: flex;align-items: center;margin-top: 10px;font-size: 14px;">
						<div>边框圆角</div>
						<div
							style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
							<div style="display: flex;flex-direction: column;align-items: center;">
								<input @input="changeContainerBorderRadius"
									v-model="dataItem.breadcrumb.border.borderRadius[0]"
									style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
								<div style="margin-top: 2px;">左上</div>
							</div>
							<div style="display: flex;flex-direction: column;align-items: center;">
								<input @input="changeContainerBorderRadius"
									v-model="dataItem.breadcrumb.border.borderRadius[1]"
									style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
								<div style="margin-top: 2px;">右上</div>
							</div>
							<div style="display: flex;flex-direction: column;align-items: center;">
								<input @input="changeContainerBorderRadius"
									v-model="dataItem.breadcrumb.border.borderRadius[2]"
									style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
								<div style="margin-top: 2px;">右下</div>
							</div>
							<div style="display: flex;flex-direction: column;align-items: center;">
								<input @input="changeContainerBorderRadius"
									v-model="dataItem.breadcrumb.border.borderRadius[3]"
									style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
								<div style="margin-top: 2px;">左下</div>
							</div>
							<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
								<i @click="borderContainerRadiusAll = !borderContainerRadiusAll"
									:style="{color:borderContainerRadiusAll?'#8c62ff':'#000'}"
									style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
									class="el-icon-paperclip tit-icon"></i>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			
			
			<div style="display: flex;align-items: center;">
				<div style="display: flex;align-items: center;">
					<div style="padding: 10px;display: flex;align-items: center;margin-top: 10px;font-size: 14px;">
						<div>内边距</div>
						<div
							style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;margin-left: 20px;">
							<div style="display: flex;flex-direction: column;align-items: center;">
								<input @input="paddingSet" v-model="dataItem.breadcrumb.padding[0]"
									style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
								<div style="margin-top: 2px;">顶部</div>
							</div>
							<div style="display: flex;flex-direction: column;align-items: center;">
								<input @input="paddingSet" v-model="dataItem.breadcrumb.padding[2]"
									style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
								<div style="margin-top: 2px;">左侧</div>
							</div>
							<div style="display: flex;flex-direction: column;align-items: center;">
								<input @input="paddingSet" v-model="dataItem.breadcrumb.padding[1]"
									style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
								<div style="margin-top: 2px;">底部</div>
							</div>
							<div style="display: flex;flex-direction: column;align-items: center;">
								<input @input="paddingSet" v-model="dataItem.breadcrumb.padding[3]"
									style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
								<div style="margin-top: 2px;">右侧</div>
							</div>
							<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
								<i @click="paddingAll = !paddingAll" :style="{color:paddingAll?'#8c62ff':'#000'}"
									style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
									class="el-icon-paperclip tit-icon"></i>
							</div>
						</div>
					</div>
				</div>
			
			
				<div style="display: flex;align-items: center;">
					<div style="padding: 10px;display: flex;align-items: center;margin-top: 10px;font-size: 14px;">
						<div>外边距</div>
						<div
							style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;margin-left: 20px;">
							<div style="display: flex;flex-direction: column;align-items: center;">
								<input @input="marginSet" v-model="dataItem.breadcrumb.margin[0]"
									style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
								<div style="margin-top: 2px;">顶部</div>
							</div>
							<div style="display: flex;flex-direction: column;align-items: center;">
								<input @input="marginSet" v-model="dataItem.breadcrumb.margin[2]"
									style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
								<div style="margin-top: 2px;">左侧</div>
							</div>
							<div style="display: flex;flex-direction: column;align-items: center;">
								<input @input="marginSet" v-model="dataItem.breadcrumb.margin[1]"
									style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
								<div style="margin-top: 2px;">底部</div>
							</div>
							<div style="display: flex;flex-direction: column;align-items: center;">
								<input @input="marginSet" v-model="dataItem.breadcrumb.margin[3]"
									style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
								<div style="margin-top: 2px;">右侧</div>
							</div>
							<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
								<i @click="marginAll = !marginAll" :style="{color:marginAll?'#8c62ff':'#000'}"
									style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
									class="el-icon-paperclip tit-icon"></i>
							</div>
						</div>
					</div>
				</div>
			</div>




			<div style="padding: 10px;display: flex;">
				<div style="font-size: 14px;">背景宽度设置</div>
				<div style="margin-left: 10px;">
					<div style="display: flex;align-items: center;font-size: 12px;cursor: pointer;">
						<div @click="dataItem.breadcrumb.type = 'allWidth'"
							:style="{backgroundColor: dataItem.breadcrumb.type == 'allWidth'?'#605bf6':'#fff',color: dataItem.breadcrumb.type == 'allWidth'?'#fff':'#000'}"
							style="width: 120px;border-radius: 6px 0px 0px 6px;padding: 4px;border: solid 1px #c7c7c7;text-align: center;">
							全宽
						</div>
						<div @click="dataItem.breadcrumb.type = 'box'"
							:style="{backgroundColor: dataItem.breadcrumb.type == 'box'?'#605bf6':'#fff',color: dataItem.breadcrumb.type == 'box'?'#fff':'#000'}"
							style="width: 120px;padding: 4px;border: solid 1px #c7c7c7;border-radius: 0px 6px 6px 0px;text-align: center;">
							盒装
						</div>
					</div>
				</div>
			</div>

			<div v-if="dataItem.breadcrumb.type == 'box'"
				style="margin-left: 10px;display: flex;align-items: center;margin-bottom: 10px;">
				<div style="font-size: 14px;">盒装宽度设置</div>
				<el-input size="small" @input="ipt(dataItem.breadcrumb)" @change="changeIpt(dataItem.breadcrumb)"
					style="width: 259px;margin-top: 10px;margin-left: 10px;" placeholder="请输入内容"
					v-model="dataItem.breadcrumb.typeBoxWidth" clearable>
					<template slot="append">px</template>
				</el-input>
			</div>

			<div style="display: flex;align-items: center;margin-top: 10px;">
				<div style="margin-left: 10px;display: flex;align-items: center;font-size: 14px;">
					<div>全局背景设置</div>
					<div style="display: flex;align-items: center;margin-left: 10px;">
						<div @click="dataItem.breadcrumb.bgType = ''"
							:style="{backgroundColor:dataItem.breadcrumb.bgType == ''?'#8c62ff':'#fff',color:dataItem.breadcrumb.bgType == ''?'#fff':'#000',border:dataItem.breadcrumb.bgType == ''?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="padding: 4px 0px;width: 68px;text-align: center;cursor: pointer;">
							<span style="scale: 0.85;">无</span>
						</div>
						<div @click="dataItem.breadcrumb.bgType = 'color'"
							:style="{backgroundColor:dataItem.breadcrumb.bgType == 'color'?'#8c62ff':'#fff',color:dataItem.breadcrumb.bgType == 'color'?'#fff':'#000',border:dataItem.breadcrumb.bgType == 'color'?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="padding: 4px 0px;width: 68px;text-align: center;cursor: pointer;">
							<span style="scale: 0.85;">纯色背景</span>
						</div>
						<div @click="dataItem.breadcrumb.bgType = 'gradient'"
							:style="{backgroundColor:dataItem.breadcrumb.bgType == 'gradient'?'#8c62ff':'#fff',color:dataItem.breadcrumb.bgType == 'gradient'?'#fff':'#000',border:dataItem.breadcrumb.bgType == 'gradient'?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="padding: 4px 0px;width: 68px;text-align: center;cursor: pointer;">
							<span style="scale: 0.85;">渐变背景</span>
						</div>
					</div>
				</div>
				<div v-if="dataItem.breadcrumb.bgType == 'color'"
					style="display: flex;align-items: center;font-size: 14px;margin-left: 10px;">
					<div>背景纯色设置</div>
					<el-color-picker size="small" style="margin-left: 10px;" v-model="dataItem.breadcrumb.bgColor"></el-color-picker>
				</div>
				
				<div v-if="dataItem.breadcrumb.bgType == 'gradient'"
					style="display: flex;align-items: center;margin-left: 10px;">
					<div style="font-size: 14px;">背景渐变设置</div>
					<div style="margin-left: 10px;">
						<div style="display: flex;flex-direction: column;">
							<el-input size="small" style="width: 260px;margin-top: 4px;" type="textarea" :rows="1" placeholder="请输入内容"
								v-model="dataItem.breadcrumb.bgGradient">
							</el-input>
						</div>
						<div style="margin-top: 6px;font-size: 12px;color: #55aaff;transform: scale(0.85);">
							需要自定义模板设置请访问 <a target="_blank" style="margin-left: 4px;"  href="https://www.eggradients.com/gradient-maker">gradient-maker</a> 
						</div>
					</div>
				</div>
			</div>

			<div style="display: flex;align-items: center;">
				<div v-if="dataItem.breadcrumb.type == 'box'"
					style="margin-left: 10px;display: flex;align-items: center;font-size: 14px;margin-top: 10px;">
					<div>盒装背景设置</div>
					<div style="display: flex;align-items: center;margin-left: 10px;">
						<div @click="dataItem.breadcrumb.boxBgColor = ''"
							:style="{backgroundColor:dataItem.breadcrumb.boxBgColor == ''?'#8c62ff':'#fff',color:dataItem.breadcrumb.boxBgColor == ''?'#fff':'#000',border:dataItem.breadcrumb.boxBgColor == ''?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="padding: 4px 0px;width: 68px;text-align: center;cursor: pointer;">
							<span style="scale: 0.85;">无</span>
						</div>
						<div @click="dataItem.breadcrumb.boxBgColor = 'color'"
							:style="{backgroundColor:dataItem.breadcrumb.boxBgColor == 'color'?'#8c62ff':'#fff',color:dataItem.breadcrumb.boxBgColor == 'color'?'#fff':'#000',border:dataItem.breadcrumb.boxBgColor == 'color'?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="padding: 4px 0px;width: 68px;text-align: center;cursor: pointer;">
							<span style="scale: 0.85;">纯色背景</span>
						</div>
						<div @click="dataItem.breadcrumb.boxBgColor = 'gradient'"
							:style="{backgroundColor:dataItem.breadcrumb.boxBgColor == 'gradient'?'#8c62ff':'#fff',color:dataItem.breadcrumb.boxBgColor == 'gradient'?'#fff':'#000',border:dataItem.breadcrumb.boxBgColor == 'gradient'?'solid 1px #8c62ff':'solid 1px #959595' }"
							style="padding: 4px 0px;width: 68px;text-align: center;cursor: pointer;">
							<span style="scale: 0.85;">渐变背景</span>
						</div>
					</div>
				</div>
				<div v-if="dataItem.breadcrumb.boxBgColor == 'color' && dataItem.breadcrumb.type == 'box'"
					style="display: flex;align-items: center;font-size: 14px;margin-left: 10px;">
					<div>背景纯色设置</div>
					<el-color-picker size="small" style="margin-left: 10px;" v-model="dataItem.breadcrumb.boxColor"></el-color-picker>
				</div>
				
				
				<div v-if="dataItem.breadcrumb.boxBgColor == 'gradient' && dataItem.breadcrumb.type == 'box'"
					style="display: flex;align-items: center;margin-left: 10px;">
					<div style="font-size: 14px;">背景渐变设置</div>
					<div style="margin-left: 10px;">
						<div style="display: flex;flex-direction: column;">
							<el-input  size="small"  style="width: 260px;margin-top: 4px;" type="textarea" :rows="1" placeholder="请输入内容"
								v-model="dataItem.breadcrumb.boxGradient">
							</el-input>
						</div>
						<div style="margin-top: 6px;font-size: 12px;color: #55aaff;transform: scale(0.85);">
							需要自定义模板设置请访问 <a target="_blank" style="margin-left: 4px;"  href="https://www.eggradients.com/gradient-maker">gradient-maker</a> 
						</div>
					</div>
				</div>
			</div>
			<div style="width: 100%;height: 20px;"></div>
		</div>
		<div style="width: 100%;background-color: #fff;margin-top: 15px;">
			<div style="padding: 10px;font-weight: bold;font-size: 18px;">弹窗设置</div>
			<div style="height:  1px;background-color: #c7c7c7;margin: auto;margin: 6px;"></div>
			<set-global-dialog :dataItem="dataItem" :fontList="fontList" :fontFamilyName="fontFamilyName"></set-global-dialog>
			<div style="width: 100%;height: 20px;"></div>
		</div>
		<!-- <div style="height: 1px;width: 33%;;margin-left: 3%;">
			
		</div> -->
	</div>
</template>

<script>
	import setGlobalDialog from './setGlobalDialog.vue'
	export default {
		components:{
			setGlobalDialog
		},
		props: {
			dataItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			fontList: {
				type: Array,
				default: () => {
					return []
				}
			},
			fontFamilyName: {
				type: String,
				default: ''
			},
		},

		data() {
			return {
				borderContainerRadiusAll: true,
				paddingAll: true,
				marginAll: true,
				borderContainerSizeAll: true
			}
		},
		mounted() {
			if (this.dataItem.breadcrumb.fontFamily == '') {
				this.dataItem.breadcrumb.fontFamily = this.fontFamilyName
			}
		},
		methods: {
			sizeTit(e) {
				e.titBoxWidth = e.titBoxWidth.replace(/\D/g, '')
			},
			changeContainerBorderRadius(e) {
				if (this.borderContainerRadiusAll) {
					this.dataItem.breadcrumb.border.borderRadius = []
					this.dataItem.breadcrumb.border.borderRadius.push(e.target.value)
					this.dataItem.breadcrumb.border.borderRadius.push(e.target.value)
					this.dataItem.breadcrumb.border.borderRadius.push(e.target.value)
					this.dataItem.breadcrumb.border.borderRadius.push(e.target.value)
				}
			},
			iptTit(e) {
				e.fontSize = e.fontSize.replace(/\D/g, '')
			},
			ipt(e) {
				e.typeBoxWidth = e.typeBoxWidth.replace(/\D/g, '')
			},
			changeIpt(e) {

			},
			paddingSet(e) {
				console.log('event.target.value', event.target.value)
				if (this.paddingAll) {
					this.dataItem.breadcrumb.padding = []
					this.dataItem.breadcrumb.padding.push(e.target.value)
					this.dataItem.breadcrumb.padding.push(e.target.value)
					this.dataItem.breadcrumb.padding.push(e.target.value)
					this.dataItem.breadcrumb.padding.push(e.target.value)
				}
			},
			marginSet(e) {
				if (this.marginAll) {
					this.dataItem.breadcrumb.margin = []
					this.dataItem.breadcrumb.margin.push(e.target.value)
					this.dataItem.breadcrumb.margin.push(e.target.value)
					this.dataItem.breadcrumb.margin.push(e.target.value)
					this.dataItem.breadcrumb.margin.push(e.target.value)
				}
			},
			changeContainerSize(e) {
				if (this.borderContainerSizeAll) {
					this.dataItem.breadcrumb.border.borderSize = []
					this.dataItem.breadcrumb.border.borderSize.push(e.target.value)
					this.dataItem.breadcrumb.border.borderSize.push(e.target.value)
					this.dataItem.breadcrumb.border.borderSize.push(e.target.value)
					this.dataItem.breadcrumb.border.borderSize.push(e.target.value)
				}
			},
		}
	}
</script>

<style scoped>
	input:focus {
		outline: none;
		border: 1px solid #242754;
		border-radius: 3px;
	}

	input {
		outline: none;
		border: 1px solid #c1c1c1;
		border-radius: 5px;
	}
</style>